import * as React from "react";
import { Icon } from "@chakra-ui/react";
const Internal = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#233D43", d: "M9.904 7h5.029c0-2.762-2.253-5-5.029-5a5 5 0 0 0-5.013 5c0 2.76 2.252 4.999 5.013 4.999z" }), /* @__PURE__ */ React.createElement("path", { fill: "#E95517", d: "M10.878 13H5.85c0 2.762 2.252 5 5.028 5a5 5 0 0 0 5.014-5c0-2.76-2.253-4.999-5.014-4.999z" }));
const SvgSeismicLightmode = (props) => {
  return /* @__PURE__ */ React.createElement(Icon, { as: Internal, ...props });
};
export default SvgSeismicLightmode;
